export default "__VITE_ASSET__DSLjXz8F__"